import { EventName } from '@jumbo/constants/electron/EventName';
import { TypeNotify } from '@jumbo/constants/electron/TypeNotify';
import delay from 'helpers/delay';
import { random } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    cleanListen,
    listenCheckAccountFB,
    listenCloseBrowser,
    listenOpenBrowser,
    listenOpeningBrowser,
    listenUpdateAccounts,
    openingBrowserWithAction,
    removeAccountForAction
} from 'redux/actions/Accounts';
import { listenSyncGroup } from 'redux/actions/Groups';
import { createLog } from 'redux/actions/Logs';
import { notificationError, notificationSuccess, notificationWarning } from 'redux/actions/Notification';
import { listenAddGroupFB, listenAddMultiGroupFB, listenDeleteNotJoinGroup } from 'redux/actions/Pages';
import { API } from 'services/apiResource';
import apiServices from 'services/apiServices';
const { ipcRenderer } = window.require('electron');

function InitAllEvent({ children }) {
    const { accountsForAction, dataAccounts, accountShareWithMe } = useSelector(
        ({ manageAccountFacebook }) => manageAccountFacebook,
    );
    const dispatch = useDispatch();

    useEffect(() => {
        ipcRenderer.on(EventName.Notification, (event, { status, message, _id }) => {
            if ([TypeNotify.SUCCESS, TypeNotify.ERROR].includes(status)) {
                setTimeout(() => {
                    dispatch(createLog({ status, message, account_id: _id }))
                }, random(100, 1000));
            }

            if (status === TypeNotify.SUCCESS) {
                dispatch(notificationSuccess(message))
                return;
            };
            if (status === TypeNotify.ERROR) {
                dispatch(notificationError(message));
                return;
            }
            dispatch(notificationWarning(message));
        });

        dispatch(listenCloseBrowser());
        dispatch(listenOpeningBrowser());
        dispatch(listenOpenBrowser());
        dispatch(listenUpdateAccounts());
        dispatch(listenAddGroupFB());
        dispatch(listenAddMultiGroupFB())
        dispatch(listenCheckAccountFB());
        dispatch(listenDeleteNotJoinGroup());
        dispatch(listenSyncGroup());
        ipcRenderer.on(EventName.UpdateInfo, (event, obj) => {
            apiServices.put(API.CODE.update, obj);
        });

        return () => {
            dispatch(cleanListen(EventName.GetOpeningBrowser));
            dispatch(cleanListen(EventName.Notification));
            dispatch(cleanListen(EventName.GetOpenBrowser));
            dispatch(cleanListen(EventName.GetCloseBrowser));
            dispatch(cleanListen(EventName.UpdateStatusAccount));
            dispatch(cleanListen(EventName.UpdateInfo));
            dispatch(cleanListen(EventName.addGroupFB));
            dispatch(cleanListen(EventName.statusCheckCookie));
            dispatch(cleanListen(EventName.deleteNotJoinGroup));
            dispatch(cleanListen(EventName.dataSyncGroup));
            dispatch(cleanListen(EventName.addMultiGroupFB));
        };
    }, [dispatch]);

    useEffect(() => {
        ipcRenderer.on(EventName.openNewProcess, async (event, obj) => {
            if (accountsForAction.length > 0) {
                for (let index = 0; index < accountsForAction.length; index++) {
                    let account = accountsForAction[index];
                    if (account.script_id !== obj.script_id) {
                        continue;
                    }
                    let currentAccount = dataAccounts.find(item => item._id === account._id);
                    currentAccount = currentAccount ? currentAccount : accountShareWithMe.find(item => item._id === account._id);
                    if (!currentAccount) {
                        continue;
                    }
                    if (currentAccount.state !== 2) {
                        let { actionType, script, groupAction } = account;
                        account.i = obj.i;
                        account.state = '';
                        dispatch(openingBrowserWithAction(account, actionType, script, groupAction));
                        dispatch(removeAccountForAction(index));
                        break;
                    } else {
                        dispatch(
                            notificationError(
                                `${account.email
                                    ? account.email
                                    : account.uuid
                                } đang mở`,
                            ),
                        );
                        await delay(3000);
                    }
                }
            }
        });
        return () => {
            dispatch(cleanListen(EventName.openNewProcess));
        };
    }, [accountsForAction, dispatch]);
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
}

export default InitAllEvent;
